import { Container } from '@algbra/ui/components/Grid/Grid'
import Whitespace from '@algbra/ui/components/Whitespace/Whitespace'
import { GatsbyResolvedAsset } from '@algbra/ui/types/image'
import { resolveAsImage } from '@algbra/ui/resolvers'
import { mapIndexed } from 'rambdax'

import styles from './ButtonList.module.scss'
import { GatsbyImage } from 'gatsby-plugin-image'

export type ButtonItem = {
  id: string
  title: string
  image: GatsbyResolvedAsset
  bgHex: string
}

export type ZoneButtonListProps = {
  __typename: 'StrapiGQL_ComponentZonesButtonList'
  buttons?: ButtonItem[]
}

export function ButtonItem({ title, image, bgHex }: ButtonItem): JSX.Element {
  return (
    <div className={styles.item} style={{ backgroundColor: bgHex }}>
      <GatsbyImage
        image={resolveAsImage(image)}
        alt={'Algbra'}
        loading="lazy"
      />
      <div>{title}</div>
    </div>
  )
}

export default function ZoneButtonList({ buttons }: ZoneButtonListProps) {
  return (
    <Whitespace type="lg">
      <Container className={styles.container}>
        <div className={styles.buttonContainer}>
          {mapIndexed(
            (item: ButtonItem) => (
              <ButtonItem {...item} key={item.id} />
            ),
            buttons
          )}
        </div>
      </Container>
    </Whitespace>
  )
}
